import { apiUrl2 } from '../../settings'

export const getProfitLossDataUrl = () => {
  return apiUrl2 + '/api/profit-loss-statement'
}